<div class="marg-btn">
    <div>
        <button mat-raised-button color="warn" (click)="save()">Sauvegarder</button>
    </div>
    <div *ngIf="surveyEnd == true">
        <button mat-raised-button color="primary" (click)="save()">Terminer le questionnaire</button>
    </div>
</div>